(function ($) {
  function fadeOut(el) {
    el.style.opacity = 1;
    (function fade() {
      if ((el.style.opacity -= 0.1) < 0) {
        el.style.display = "none";
      } else {
        requestAnimationFrame(fade);
      }
    })();
  }
  function fadeIn(el, display) {
    el.style.opacity = 0;
    el.style.display = display || "block";
    (function fade() {
      var val = parseFloat(el.style.opacity);
      if (!((val += 0.1) > 1)) {
        el.style.opacity = val;
        requestAnimationFrame(fade);
      }
    })();
  }
  $(".yms-slides").slick({
    accessibility: false
  });
  $(".fancybox").fancybox({
    padding: 0
  });
  $(".small-gallery__slider").slick({
    accessibility: false,
    slidesToShow: 4,
    responsive: [{
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        variableWidth: true,
        arrows: false,
        dots: true
      }
    }]
  });
  $(".text-slider__slides").slick({
    responsive: [{
      breakpoint: 900,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        variableWidth: true
        //arrows: false
      }
    }]
  });
  $(".list-slider__slides").slick({
    responsive: [{
      breakpoint: 600,
      settings: {
        dots: true
      }
    }]
  });
  $(".bg-slider__slides").slick({
    accessibility: false,
    responsive: [{
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        variableWidth: true
      }
    }]
  });
  var myTabs = document.querySelectorAll(".tabs__nav a");
  let tab_transition = 0;
  function myTabClicks(tabClickEvent) {
    if (tab_transition == 0) {
      tab_transition = 1;
      for (var i = 0; i < myTabs.length; i++) {
        myTabs[i].classList.remove("active");
      }
      var clickedTab = tabClickEvent.currentTarget;
      clickedTab.classList.add("active");
      tabClickEvent.preventDefault();
      var myContentPanes = document.querySelectorAll(".tab");
      for (i = 0; i < myContentPanes.length; i++) {
        //myContentPanes[i].classList.remove("active2");
        const this_tab = myContentPanes[i];
        this_tab.classList.remove("active");
        // setTimeout(function(){
        // 	console.log(this_tab);
        //
        // },700);
      }
      var anchorReference = tabClickEvent.target;
      var activePaneId = anchorReference.getAttribute("href");
      var activePane = document.querySelector(activePaneId);
      activePane.classList.add("active");
      setTimeout(function () {
        // setTimeout(function(){
        // 	activePane.classList.add("active2");
        // },20)
      }, 700);
      setTimeout(function () {
        tab_transition = 0;
      }, 0);
    }
  }
  for (let i = 0; i < myTabs.length; i++) {
    myTabs[i].addEventListener("click", function (event) {
      event.preventDefault();
    });
    myTabs[i].addEventListener("mouseover", myTabClicks);
  }
  var header_menu = document.querySelector(".header__menu");
  header_menu.addEventListener("click", function (event) {
    event.stopPropagation();
    document.querySelector(".header__nav").classList.toggle("open");
  });
  document.querySelector(".header__nav").addEventListener("click", function (event) {
    event.stopPropagation();
  });
  document.querySelector("body").addEventListener("click", function () {
    document.querySelector(".header__nav").classList.remove("open");
  });
  var header_close = document.querySelector(".header__close-nav");
  header_close.addEventListener("click", function () {
    document.querySelector(".header__nav").classList.remove("open");
  });
  var headerLogo = document.querySelector(".header__logo img");
  var logoSrc = headerLogo.getAttribute("src");
  var logoData = headerLogo.getAttribute("data-scroll");
  var winWidth = window.innerWidth;
  var header_video = document.querySelector(".video-hero");
  var header_app = document.querySelector(".app-hero");
  var headerEl = document.getElementById("header");
  var win_width = window.innerWidth;
  if (!header_video && !header_app || win_width < 600) {
    headerEl.classList.add("scroll");
    headerLogo.setAttribute("src", logoData);
  }
  if (win_width > 600) {
    var tabs_height = $(".tab").outerHeight();
    $(".tabs__content").height(tabs_height);
  } else {
    $(".menu-item-has-children").children("a").click(function (event) {
      event.preventDefault();
      $(this).siblings(".sub-menu").slideToggle();
    });
  }
  document.addEventListener("wpcf7mailsent", function (event) {
    $(".form-content").slideUp();
  }, false);
  function scrollDown() {
    var top = window.scrollY;

    //Header animation
    if ((header_video || header_app) && win_width > 600) {
      if (top > 40) {
        headerEl.classList.add("scroll");
        headerLogo.setAttribute("src", logoData);
      } else {
        headerEl.classList.remove("scroll");
        headerLogo.setAttribute("src", logoSrc);
      }
    }

    //Scroll animations
    var animatedEl = document.getElementsByClassName("animate-fade");
    var h = window.innerHeight;
    var i;
    for (i = 0; i < animatedEl.length; i++) {
      var viewportOffset = animatedEl[i].getBoundingClientRect();
      var topPos = viewportOffset.top;
      if (topPos <= h * 0.8) {
        animatedEl[i].classList.add("fade-in");
      }
    }

    // Lazy Load
    var lazy_image = document.querySelectorAll("[data-src]");
    if (lazy_image) {
      //console.log(lazy_image);
      for (var l = 0; l < lazy_image.length; l++) {
        var data_src = lazy_image[l].dataset.src;
        var viewportOffset = lazy_image[l].getBoundingClientRect();
        var topPos = viewportOffset.top;
        if (topPos <= h * 1.3) {
          lazy_image[l].setAttribute("src", data_src);
          lazy_image[l].removeAttribute("data-src");
          lazy_image[l].classList.add("loaded");
        }
      }
    }
    var lazy_bg = document.querySelectorAll("[data-bg]");
    if (lazy_bg) {
      //console.log(lazy_bg);
      for (var l = 0; l < lazy_bg.length; l++) {
        var data_src = lazy_bg[l].dataset.bg;
        var viewportOffset = lazy_bg[l].getBoundingClientRect();
        var topPos = viewportOffset.top;
        if (topPos <= h * 1.3) {
          lazy_bg[l].setAttribute("style", "background-image:url(" + data_src + ")");
          lazy_bg[l].removeAttribute("data-bg");
          lazy_bg[l].classList.add("loaded");
        }
      }
    }
  }
  scrollDown();
  setTimeout(function () {
    document.querySelector("body").classList.add("loaded");
  }, 800);
  window.addEventListener("scroll", function (e) {
    scrollDown();
  });
  $(".comparison-table__tabs").on("click", "li", function () {
    var pos = $(this).index() + 2;
    $(".comparison-table__table tr").find("td:not(:eq(0))").hide();
    $(".comparison-table__table td:nth-child(" + pos + ")").css("display", "table-cell");
    $(".comparison-table__table tr").find("th:not(:eq(0))").hide();
    $(".comparison-table__tabs li").removeClass("active");
    $(this).addClass("active");
  });
})(jQuery);